// extracted by mini-css-extract-plugin
export default {"layout":"StockAllPage_layout__YbGCD","flexContainer":"StockAllPage_flexContainer__QJzFG","categories":"StockAllPage_categories__bGhlY","tableBox":"StockAllPage_tableBox__nQ3k8"};